<!--  -->
<template>
  <div>
    <el-radio-group v-model="radio" style="margin-bottom:15px">
      <el-radio-button :label="1">文本</el-radio-button>
      <el-radio-button :label="2">图文</el-radio-button>
      <el-radio-button :label="3">图片</el-radio-button>
      <el-radio-button :label="5">名片</el-radio-button>
      <!-- <el-radio-button :label="4">名片</el-radio-button> -->
    </el-radio-group>
    <div class="dawdf">
      <div>延时时长：</div>
      <div>
        <el-input
          v-model="keyWord"
          class="durction"

          type="number"
          placeholder="请输入内容"
          :controls="false"
          @mousewheel.native.prevent
          @keyup.native="prevent($event)"
        />

        <!-- <el-input v-model.number="keyWord" class="input-view" placeholder="请输入内容" οninput="value=value.replace(/[^0-9]/g,'')" /> -->

      </div>
    </div>
    <div v-if="radio == 1" class="sewawaBox">
      <div class="sewawa" style="margin-top:20px;margin-bottom:20px">
        <div style="width: 70px;text-align: right;">消息：</div>
        <el-input v-model="messagetext" style="width:495px" type="textarea" placeholder="请输入消息文字" />
      </div>
    </div>

    <div v-if="radio == 2">
      <div class="dawdf">
        <div class="saera">标题：</div>
        <div><el-input v-model="title" placeholder="请输入内容" /></div>
      </div>
      <div class="dawdf">
        <div class="saera">链接：</div>
        <div><el-input v-model="url" placeholder="请输入内容" /></div>
      </div>
      <div class="dawdf sewawaBox">
        <div class="saera">描述：</div>
        <el-input v-model="desc" class="sewawa" type="textarea" placeholder="请输入描述" />
      </div>
      <div class="dawdf">
        <div class="saera">
          上传：
        </div>
        <div
          v-loading="loading"
          style="display: flex; flex-wrap: wrap;"
          :class="[updatapath.length ? '' : 'wrwaw']"
        >
          <div v-if="updatapath.length" style=" display: flex;">
            <div v-for="itm,index in updatapath" :key="itm.id" class="imgBox">
              <img
                :src="itm.src"
                class="updata_casr"
              >
              <div class="mantle">
                <i class="el-icon-delete-solid" style="cursor: pointer;" title="删除" @click="imgDelete(itm)" />
                <i class="el-icon-sort" title="替换" style="cursor: pointer;" @click="imgReplace(itm, index)" />
              </div>
            </div>

          </div>
          <div
            style="width: 120px; height: 120px;"
            :class="['updatabocwr']"
            @click="$refs.file.click()"
          >
            <input
              ref="file"
              style="display:none;"
              type="file"
              multiple
              accept="image/gif,image/jpg,image/jpeg,image/png"
              @change="uploadPictures"
            >
            <i
              class="el-icon-upload"
            />
          </div>
        </div>

      </div>
    </div>

    <div v-if="radio == 3">
      <div class="dawdf">
        <div class="saera">
          上传：
        </div>
        <div
          v-loading="loading1"
          style="display: flex; flex-wrap: wrap;"
          :class="[updatapath1.length ? '' : 'wrwaw']"
        >
          <div v-if="updatapath1.length" style=" display: flex;">
            <div v-for="itm,index in updatapath1" :key="itm.id" class="imgBox">
              <img
                :src="itm.src"
                class="updata_casr"
              >
              <div class="mantle">
                <i class="el-icon-delete-solid" style="cursor: pointer;" title="删除" @click="imgDelete(itm)" />
                <i class="el-icon-sort" title="替换" style="cursor: pointer;" @click="imgReplace(itm, index)" />
              </div>
            </div>

          </div>
          <div
            style="width: 120px; height: 120px;"
            :class="['updatabocwr']"
            @click="$refs.file1.click()"
          >
            <input
              ref="file1"
              style="display:none;"
              type="file"
              multiple
              accept="image/gif,image/jpg,image/jpeg,image/png"
              @change="uploadPictures1"
            >
            <i
              class="el-icon-upload"
            />
          </div>
        </div>

      </div>
    </div>
    <div v-if="radio == 5">
      <div class="dawdf">
        <div class="saera">
          名片：
        </div>
        <!-- <div>
          <el-tag v-if="contactsname!=''">{{ contactsname }}</el-tag>
          <el-button type="primary" size="mini" style="margin-left:10px" @click="contacts">选择联系人</el-button>
        </div> -->
        <div class="name_picitr">
          <el-select v-model="contactsname" filterable multiple placeholder="请选择">
            <el-option
              v-for="item in tableDatar"
              :key="item.follow_user_id"
              :label="item.follow_user_id"
              :value="item.follow_user_id"
            />
          </el-select>
        </div>
      </div>
    </div>
    <div>
      <el-button type="primary" @click="btnclick">确定</el-button>
    </div>
    <!-- <el-button
      type="primary"
      :disabled="processingOrNot"
      :icon="processingOrNot ? 'el-icon-loading' : 'el-icon-thumb'"
      @click="processingProgram"
    >{{ wenbenid1 ? '修改' : '添加' }}</el-button>

    <el-select
      v-model="currentType"
      placeholder="请选择"
      style="margin-left: 15px; width: 100px;"
      @change="switchType"
    >
      <el-option
        v-for="item in [{id: 0, value: '全部'}, {id: 1, value: '文本'}, {id: 2, value: '图文'}, {id: 3, value: '图片'},{id: 5, value: '名片'}]"
        :key="item.id"
        :label="item.value"
        :value="item.id"
      />
    </el-select> -->

    <!-- <el-table
      v-loading="loading2"
      height="300"
      :data="tableDatas.list"
      border
      style="width: 100%;margin-top:10px"
    >
      <el-table-column
        fixed
        prop="msg_type"
        align="center"
        label="类型"
        width="100"
      >
        <template scope="scope">
          <div v-if="scope.row.msg_type == 1">文本</div>
          <div v-if="scope.row.msg_type == 2">图文</div>
          <div v-if="scope.row.msg_type == 3">图片</div>
          <div v-if="scope.row.msg_type == 5">名片</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="duration"
        align="center"
        label="延迟时长"
        width="100"
      />
      <el-table-column
        prop="scope.row.msg_data"
        align="center"
        label="消息"
        width="180"
      >
        <template scope="scope">
          <span v-if="scope.row.msg_type == 1">{{ scope.row.msg_data[0] && scope.row.msg_data[0].content }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="scope.row.msg_data.title"
        align="center"
        label="标题"
        width="180"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.msg_type === 2">{{ scope.row.msg_data[0].title }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="scope.row.msg_data.title"
        align="center"
        label="链接"
        width="180"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.msg_type === 2">{{ scope.row.msg_data[0].url }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="描述"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.msg_type === 2"
            placement="top-start"
            title="描述"
            width="200"
            trigger="hover"
            :content="scope.row.msg_data.desc"
          >
            <p slot="reference" class="titip">{{ scope.row.msg_data[0].desc }}</p>
          </el-popover>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="scope.row.msg_data.thumb_media_url"
        align="center"
        label="图片"
        width="180"
      >
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.msg_type !== 1 && scope.row.msg_type !== 5"
            placement="top-start"
            title="描述"
            width="200"
            trigger="hover"
            :content="'详情'"
          >
            <img slot="reference" :src="scope.row.msg_data[0].thumb_media_url" style="width: 100px; height: 100px;">
            <div>
              <img v-for="item in scope.row.msg_data" :key="item.id" :src="item.thumb_media_url" style="width: 150px">
            </div>
          </el-popover>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="scope.row.msg_data.title"
        align="center"
        label="名片"
        width="180"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.msg_type === 5">
            <el-tag v-for="item,index in scope.row.msg_data" :key="index" style="margin-right:5px">{{ item }}</el-tag>
          </div>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="操作"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="wenbenid1 ? empty() : tuwenmadiw(scope.row)">{{ wenbenid1 === scope.row.id ? '取消修改' : '修改' }}</el-button>
          <el-button type="text" @click="delect(scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table> -->
    <!-- <PaginationRight
      :total="tableDatas.total"
      :page-sizes="[5]"
      @size-change="fetchPageSizetwo"
      @current-change="fetchCurrentPagetwo"
    /> -->
    <!-- 选择联系人 -->
    <el-dialog
      title="选择"
      :visible.sync="dialogVisible"
      :append-to-body="true"
    >
      <choosecontacts ref="choosecontactsview" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import { customeradd, workwechatlist, workWechatupdata, workWechatdestroy, newMaterial } from '@/api/sourceMaterial1.js'
import { getFollowUserList } from '@/api/providerAccountManagement/servicePorviderList1.js'
import { sort } from '@/api/weChatMerchants1.js'
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
// import PaginationRight from '@/components/PaginationRight/index.vue'
import choosecontacts from './choosecontacts.vue'
import getNowDate from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    // PaginationRight,
    choosecontacts
  },
  mixins: [getNowDate],
  data() {
    return {
      wenbenid1: null,
      processingOrNot: false, // 是否创建中
      currentType: 0, // 当前类型
      currentlySelected: null, // 当前选中
      replace1Index: null,
      replace2Index: null,
      disabled: false,
      imtedisabled: false,
      loading: false,
      loading2: false,
      radio: 1,
      id: null,
      messagetext: '',
      wenbentype: true,
      keyWord: '',
      page: 1,
      pageSize: 5,
      title: '',
      url: '',
      desc: '',
      token: null,
      updatapath: [],
      updatapath1: [],
      tableData: [],
      tableDatas1: [],
      total: null,
      wenbenid: null,
      loading1: false,
      tableDatas: {},
      tuwentype1: true,
      tuwenid: null,
      tuwentotal: null,
      obj: {
        page: 1,
        pageSize: 5
      },
      dialogVisible: false,
      corpid: null,
      contactsname: [],
      tableDatar: []
    }
  },
  created() {
    this.getQiniuToken()
  },
  mounted() {

  },
  methods: {
    async getlist() {
      const data = await getFollowUserList({
        page: 1,
        pageSize: 100,
        corp_id: this.corpid
      })
      console.log('this.tableDatar', data)
      this.tableDatar = data.data.list
    },
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },

    send(corpid) {
      this.corpid = corpid
      // this.getListData(0)
      this.getlist()
      this.empty()
    },
    // 文本新增
    async bebtn() {
      if (this.keyWord === '') {
        this.$message.error('请输入延时时长')
        return
      }

      if (this.keyWord <= 0) {
        this.$message.error('请输入大于0')
        return
      }

      if (this.messagetext === '') {
        this.$message.error('请输入文本内容')
        return
      }

      if (this.processingOrNot) {
        this.$message.error('正在创建中...')
        return
      }

      try {
        this.processingOrNot = true
        await customeradd({
          kf_open_id: this.id,
          msg_type: 1,
          msg_data: [{ content: this.messagetext }],
          duration: this.keyWord, // 延迟秒
          push_type: 2,
          keyword: '-' // 关键字
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.messagetext = ''
        this.keyWord = ''
        this.processingOrNot = false
        this.getListData(this.currentType)
      } catch (err) {
        this.processingOrNot = false
      }
    },
    // 图文新增
    async tuwenbebtn() {
      if (this.keyWord === '') {
        this.$message.error('请输入延时时长')
        return
      }

      if (this.keyWord <= 0) {
        this.$message.error('请输入大于0')
        return
      }
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.url === '') {
        this.$message.error('请输入链接')
        return
      }
      if (this.desc === '') {
        this.$message.error('请输入描述')
        return
      }
      if (!this.updatapath.length) {
        this.$message.error('请上传图片')
        return
      }
      if (this.processingOrNot) {
        this.$message.error('正在创建中...')
        return
      }
      try {
        this.processingOrNot = true
        await customeradd({
          kf_open_id: this.id,
          msg_type: 2,
          msg_data: this.updatapath.map((item, index) => { return { title: this.title, url: this.url, desc: this.desc, thumb_media_id: this.updatapath[index].id } }),
          duration: this.keyWord,
          keyword: '-',
          push_type: 2
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.title = '' // 标题
        this.url = '' // 链接
        this.desc = '' // 描述
        this.updatapath = []
        this.keyWord = '' // 延迟
        this.processingOrNot = false
        this.getListData(this.currentType)
      } catch (err) {
        this.processingOrNot = false
      }
    },

    // 图片新增
    async tuwenbebtn1() {
      if (this.keyWord === '') {
        this.$message.error('请输入延时时长')
        return
      }

      if (this.keyWord <= 0) {
        this.$message.error('请输入大于0')
        return
      }

      if (!this.updatapath1.length) {
        this.$message.error('请上传图片')
        return
      }

      if (this.processingOrNot) {
        this.$message.error('正在创建中...')
        return
      }

      try {
        this.processingOrNot = true
        await customeradd({
          kf_open_id: this.id,
          msg_type: 3,
          msg_data: this.updatapath1.map((item, index) => { return { thumb_media_id: this.updatapath1[index].id } }),
          duration: this.keyWord,
          keyword: '-',
          push_type: 2
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.updatapath1 = []
        this.keyWord = ''
        this.processingOrNot = false
        this.getListData(this.currentType)
      } catch (err) {
        this.processingOrNot = false
      }
    },
    // 名片新增
    async tuwenbebtn2() {
      if (!this.keyWord) {
        this.$message.error('请输入延时时长')
        return
      }
      if (this.contactsname.length === 0) {
        this.$message.error('必须选择人员')
        return
      }
      try {
        this.processingOrNot = true
        await customeradd({
          kf_open_id: this.id,
          msg_type: 5,
          msg_data: this.contactsname,
          duration: this.keyWord,
          push_type: 2
        })
        this.keyWord = ''
        this.contactsname = []
        this.processingOrNot = false
        this.getListData(this.currentType)
        this.$message({
          message: '添加成功',
          type: 'success'
        })
      } catch (err) {
        this.processingOrNot = false
      }
    },
    async getListData(type) {
      this.loading2 = true
      try {
        const data = await workwechatlist({ ...this.obj, msg_type: type, kf_open_id: this.id, push_type: 2 })
        data.data.list = data.data.list.map((item) => { return { ...item, open: false } })
        this.tableDatas = data.data
        this.loading2 = false
      } catch (err) {
        this.loading2 = false
      }
    },

    // 图文上传图片
    async uploadPictures(e) {
      const fileIfon = e.target.files[0]
      const img = new Image()
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      this.loading = true
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: async(data) => {
          const datas = await newMaterial({
            type: 1,
            height: img.height,
            width: img.width,
            size: fileIfon.size,
            key: data.key
          })
          if (this.replace1Index === null) {
            this.updatapath.push({ src: datas.data.path, id: datas.data.sourceMaterialId })
          } else {
            this.updatapath[this.replace1Index] = { src: datas.data.path, id: datas.data.sourceMaterialId }
          }
          this.replace1Index = null
          this.loading = false
        }

      })
    },

    // 图片上传图片
    async uploadPictures1(e) {
      const fileIfon = e.target.files[0]
      const img = new Image()
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      this.loading1 = true
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: async(data) => {
          const datas = await newMaterial({
            type: 1,
            height: img.height,
            width: img.width,
            size: fileIfon.size,
            key: data.key
          })

          if (this.replace2Index === null) {
            this.updatapath1.push({ src: datas.data.path, id: datas.data.sourceMaterialId })
          } else {
            this.updatapath1[this.replace2Index] = { src: datas.data.path, id: datas.data.sourceMaterialId }
          }
          this.replace2Index = null
          this.loading1 = false
        }

      })
    },

    // 确认修改1
    async tuwenmodifyclick1() {
      if (this.keyWord === '') {
        this.$message.error('请输入延时时长')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.keyWord <= 0) {
        this.$message.error('请输入大于0')
        return
      }
      if (!this.messagetext) {
        this.$message.error('请填写消息')
        return
      }
      this.processingOrNot = true
      try {
        await workWechatupdata({
          id: this.wenbenid1,
          kf_open_id: this.id,
          msg_type: 1,
          msg_data: [{ content: this.messagetext }],
          duration: this.keyWord,
          push_type: 2,
          keyword: '-'
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      } catch (err) {
        this.processingOrNot = false
      }

      this.processingOrNot = false
      this.empty()
      this.getListData(this.currentType)
    },

    // 确定修改2
    async tuwenmodifyclick2() {
      if (this.keyWord === '') {
        this.$message.error('请输入延时时长')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.keyWord <= 0) {
        this.$message.error('请输入大于0')
        return
      }
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.url === '') {
        this.$message.error('请输入链接')
        return
      }
      if (this.desc === '') {
        this.$message.error('请输入描述')
        return
      }
      if (this.updataid === null) {
        this.$message.error('请上传图片')
        return
      }
      this.processingOrNot = true
      try {
        await workWechatupdata({
          id: this.wenbenid1,
          kf_open_id: this.id,
          msg_type: 2,
          msg_data: this.updatapath.map((item, index) => { return { title: this.title, url: this.url, desc: this.desc, thumb_media_id: this.updatapath[index].id } }),
          duration: this.keyWord,
          push_type: 2,
          keyword: '-'
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      } catch (err) {
        this.processingOrNot = false
      }

      this.processingOrNot = false
      this.empty()
      this.getListData(this.currentType)
    },

    // 确认修改3
    async tuwenmodifyclick3() {
      if (this.keyWord === '') {
        this.$message.error('请输入延时时长')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.keyWord <= 0) {
        this.$message.error('请输入大于0')
        return
      }
      if (this.updataid1 === null) {
        this.$message.error('请上传图片')
        return
      }
      this.processingOrNot = true
      try {
        await workWechatupdata({
          id: this.wenbenid1,
          kf_open_id: this.id,
          msg_type: 3,
          msg_data: this.updatapath1.map((item, index) => { return { thumb_media_id: this.updatapath1[index].id } }),
          duration: this.keyWord,
          push_type: 2,
          keyword: '-'
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      } catch (err) {
        this.processingOrNot = false
      }

      this.processingOrNot = false
      this.empty()
      this.getListData(this.currentType)
    },
    // 确认修改4
    async tuwenmodifyclick4() {
      if (this.keyWord === '') {
        this.$message.error('请输入延时时长')
        return
      }
      if (this.contactsname.length === 0) {
        this.$message.error('必须选择人员')
        return
      }
      this.processingOrNot = true
      try {
        await workWechatupdata({
          id: this.wenbenid1,
          kf_open_id: this.id,
          msg_type: 5,
          msg_data: this.contactsname,
          duration: this.keyWord,
          push_type: 2
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      } catch (err) {
        this.processingOrNot = false
      }

      this.processingOrNot = false
      this.empty()
      this.getListData(this.currentType)
    },
    fetchPageSizetwo(num) {
      this.obj.pageSize = num
      this.getListData(this.currentType)
    },
    fetchCurrentPagetwo(num) {
      this.obj.page = num
      this.getListData(this.currentType)
    },
    btnclick() {
      if (this.radio === 1) {
        if (this.keyWord === '') {
          this.$message.error('请输入关键字')
          return
        }
        if (this.messagetext === '') {
          this.$message.error('请输入文本内容')
          return
        }
        this.$emit('wenbenbtn', this.radio, this.messagetext, this.keyWord, this.tuwenid)
      }

      if (this.radio === 2) {
        if (this.keyWord === '') {
          this.$message.error('请输入关键字')
          return
        }
        if (this.title === '') {
          this.$message.error('请输入标题')
          return
        }
        if (this.url === '') {
          this.$message.error('请输入链接')
          return
        }
        if (this.desc === '') {
          this.$message.error('请输入描述')
          return
        }
        if (!this.updatapath.length) {
          this.$message.error('请上传图片')
          return
        }
        this.$emit('tuwenbtn', this.radio, this.keyWord, this.title, this.url, this.desc, this.updatapath, this.tuwenid)
      }

      if (this.radio === 3) {
        if (!this.keyWord) {
          this.$message.error('必须填写关键字')
          return
        }
        if (!this.updatapath1.length) {
          this.$message.error('请上传图片')
          return
        }
        this.$emit('tupianbtn', this.radio, this.updatapath1, this.keyWord, this.tuwenid)
      }
      if (this.radio === 5) {
        if (!this.keyWord) {
          this.$message.error('必须填写关键字')
          return
        }
        if (this.contactsname.length === 0) {
          this.$message.error('必须选择人员')
          return
        }
        this.$emit('mingpianbtn', this.radio, this.contactsname, this.keyWord, this.tuwenid)
      }
    },
    // 修改
    tuwenmadiw(item) {
      this.empty()
      this.wenbenid1 = item.id
      this.keyWord = item.duration
      this.currentlySelected = item.msg_type
      this.radio = item.msg_type
      if (item.msg_type === 1) {
        this.messagetext = item.msg_data[0] && item.msg_data[0].content
        return
      }

      if (item.msg_type === 2) {
        this.title = item.msg_data[0].title
        this.url = item.msg_data[0].url
        this.desc = item.msg_data[0].desc
        this.updatapath = item.msg_data.map((item) => { return { id: item.thumb_media_id, src: item.thumb_media_url } }) || []
        return
      }

      if (item.msg_type === 3) {
        this.updatapath1 = item.msg_data.map((item) => { return { id: item.thumb_media_id, src: item.thumb_media_url } }) || []
        return
      }
      if (item.msg_type === 5) {
        this.contactsname = item.msg_data && item.msg_data
        return
      }
    },

    // 删除
    delect(item) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        workWechatdestroy({
          id: item.id,
          keyword: item.keyword,
          kf_open_id: item.kf_open_id
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getListData(this.currentType)
        })
      })
    },

    prevent(e) {
      var keynum = window.event ? e.keyCode : e.which // 获取键盘码
      console.log(keynum)
      // eslint-disable-next-line eqeqeq
      if (keynum == 189 || keynum == 190 || keynum == 109 || keynum == 110) {
        this.$message.warning('禁止输入小数以及负数')
        e.target.value = ''
      }
    },

    // 清空
    empty() {
      this.currentlySelected = null
      this.wenbenid1 = null
      this.keyWord = null
      this.messagetext = null
      this.title = null
      this.url = null
      this.desc = null
      this.updatapath = []
      this.updatapath1 = []
      this.contactsname = []
    },

    // 删除图片
    imgDelete(itm) {
      const name = this.radio === 2 ? 'updatapath' : 'updatapath1'
      this[name] = this[name].filter(item => item.id !== itm.id)
    },

    // 替换图片
    imgReplace(itm, index) {
      const name = this.radio === 2 ? 'file' : 'file1'
      this.$refs[name].click()
      this.radio === 2 ? this.replace1Index = index : this.replace2Index = index
    },

    // 切换类型
    switchType(value) {
      this.getListData(value)
    },

    // 处理程序
    processingProgram() {
      const obj = {
        1: this.bebtn, // 文本新增
        2: this.tuwenbebtn, // 图文新增
        3: this.tuwenbebtn1, // 图片新增
        5: this.tuwenbebtn2 // 名片新增
      }

      const obj1 = {
        1: this.tuwenmodifyclick1,
        2: this.tuwenmodifyclick2,
        3: this.tuwenmodifyclick3,
        5: this.tuwenmodifyclick4
      }

      // 判断是否修改
      if (this.wenbenid1) {
        obj1[this.currentlySelected]()
      } else {
        obj[this.radio]()
      }
    },

    // 失去焦点
    async myBlur(row) {
      if (row.msg_sort === '' || row.msg_sort < 0) {
        this.$message.warning(row.msg_sort === '' ? '不能为空' : '必须大于等于0')
        return
      }
      await sort({ id: row.id, msg_sort: row.msg_sort })
      await this.getListData(this.currentType)
      this.$message.success('排序成功')
    },
    contacts() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.choosecontactsview.send(this.corpid)
      }, 100)
    },
    callback(item) {
      this.dialogVisible = false
      this.contactsname = item.follow_user_id
      console.log('item', item)
    },
    wenben(corpid, radio, messagetext, keyWord, tuwenid) {
      this.corpid = corpid
      this.radio = radio
      this.messagetext = messagetext
      this.keyWord = keyWord
      this.tuwenid = tuwenid
      this.getlist()
    },
    tuwen(corpid, radio, title, url, desc, updatapath, keyWord, tuwenid) {
      this.corpid = corpid
      this.radio = radio
      this.title = title
      this.url = url
      this.desc = desc
      this.updatapath = updatapath
      this.keyWord = keyWord
      this.tuwenid = tuwenid
      this.getlist()
    },
    tupian(corpid, radio, updatapath1, keyWord, tuwenid) {
      this.corpid = corpid
      this.radio = radio
      this.updatapath1 = updatapath1
      this.keyWord = keyWord
      this.tuwenid = tuwenid
      this.getlist()
    },
    mingpian(corpid, radio, contactsname, keyWord, tuwenid) {
      this.corpid = corpid
      this.radio = radio
      this.contactsname = contactsname
      this.keyWord = keyWord
      this.tuwenid = tuwenid
      this.getlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sewawa{
  display: flex;
  align-items: center;
}
.dawdf{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.saera{
  width: 70px;
  text-align: right;
}
.updata_casr{
    width: 130px;
    height: 130px;
}
.updata_casrr{
     width: 80px;
    height: 80px;
}
.updatabocwr{
background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 130px;
    height: 130px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
    text-align: center;

}
.updatabocwr i {
      font-size: 28px;
    color: #8c939d;
}
.updatabocwr i:hover {
    border: none;
}
.upda_box{
  display: flex;
  align-items: center;
}
.wrwaw :hover{
  border: 1px dashed #409eff;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}

.imgBox{
  position: relative;
  width: 130px;
  height: 130px;
  margin-right:5px;
}

.imgBox .mantle{
  display: none;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(75, 73, 73, 0.3);
  justify-content: space-around;
  align-items: center;
  color: #fff;
  font-size: 26px;
}

.imgBox:hover .mantle{
  display: flex;
}
   ::v-deep  .durction input::-webkit-outer-spin-button,
   ::v-deep  .durction input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
   ::v-deep  .durction input[type="number"]{
        -moz-appearance: textfield;
    }
   ::v-deep .durction inpit{
        border: none
    }

</style>

<style>
.sewawaBox .sewawa .el-textarea__inner{
  min-height: 110px !important;
}
</style>

